import type { Room, RoomMessage } from '@/features/veluvit/types/api.types'

export const MESSAGE_PAGE_SIZE = 50

export function mergeRoomHistory(
  previous: Room | undefined,
  incoming: Room
): Room {
  if (!previous?.messagePage || incoming.locked) return incoming
  const messages = incoming.messages
  if (incoming.messagePage) {
    const overlap = previous.messages.findIndex(
      (message) => message.id === messages[0]?.id
    )
    if (overlap < 0) return incoming
    const prefix = previous.messages.slice(0, overlap)
    const start = incoming.messagePage.start - prefix.length
    if (start < 0) return incoming
    const merged = [...prefix, ...messages]
    return {
      ...incoming,
      messages: merged,
      messagePage: {
        ...incoming.messagePage,
        start,
        nextBeforeId: start > 0 ? (merged[0]?.id ?? null) : null,
      },
    }
  }
  const first = messages.findIndex(
    (message) => message.id === previous.messages[0]?.id
  )
  const start =
    first >= 0 ? first : Math.max(0, messages.length - MESSAGE_PAGE_SIZE)
  return {
    ...incoming,
    messages: messages.slice(start),
    messageCount: messages.length,
    messagePage: {
      start,
      end: messages.length,
      total: messages.length,
      nextBeforeId: start > 0 ? messages[start].id : null,
    },
  }
}

export function prependRoomHistory(
  room: Room,
  messages: RoomMessage[],
  page: NonNullable<Room['messagePage']>
): Room {
  const existing = new Set(room.messages.map((message) => message.id))
  const prefix = messages.filter((message) => !existing.has(message.id))
  return {
    ...room,
    messages: [...prefix, ...room.messages],
    messagePage: {
      ...room.messagePage!,
      start: page.start,
      nextBeforeId: page.nextBeforeId,
      total: Math.max(page.total, room.messagePage!.total),
    },
  }
}
